import { FILTERS } from '../graphql/queries/filter';
import { useFetchItems } from './useFetchItems';
/**
 * Custom hook for fetching and managing filters.
 *
 * @param {UseFiltersProps} options - The options for the hook.
 * @param {number} [options.clientId] - The client ID.
 * @param {string} [options.returnType] - The return type.
 * @param {number[]} [options.ids] - The IDs to filter by.
 * @param {boolean} [options.skip] - Whether to skip the query.
 * @returns {Object} - The filter items, error, and loading state.
 */
export const useFilters = ({ clientId, returnType, ids, skip }) => {
    const { items, error, loading, refetch } = useFetchItems({
        fetchQuery: FILTERS,
        dataProp: 'filters',
        spec: { clientId, returnType, ids },
        skip,
    });
    return {
        items,
        error,
        loading,
        refetch,
    };
};
